/**
 * Portal Manta · mesclarPreset
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';

function mesclarPreset(estadoAtual, presetData) {
  const out = {...estadoAtual};
  Object.entries(presetData || {}).forEach(([k, v]) => {
    const atual = estadoAtual[k];
    const vazio = atual === undefined || atual === null || atual === '' || atual === 0;
    if (vazio) out[k] = v;
  });
  return out;
}

export { mesclarPreset };
export default mesclarPreset;
